import type { WorkOrderListQuery } from '@chukua/common';
import { Select } from 'antd';
import type { ListQueryControls } from '../../../../../shared/hooks/use-list-query';
import { TruckSearchSelect } from '../../../../fleet/features/trucks/public/TruckSearchSelect';

type ToolbarList = Pick<ListQueryControls<WorkOrderListQuery>, 'query' | 'setQuery'>;

const SCOPE_OPTIONS = [
  { value: 'raised_by_me', label: 'Raised by me' },
  { value: 'awaiting_my_approval', label: 'Awaiting my approval' },
];

/** The filters that are not columns: one truck, and the raiser's and approver's own queues. State, severity and source are column filters. */
export function WorkOrdersToolbar({ list }: { list: ToolbarList }) {
  const { query, setQuery } = list;

  return (
    <>
      <div className="w-full md:w-72" aria-label="Truck filter">
        <TruckSearchSelect allowClear value={query.truckId?.[0]} onChange={(truckId) => setQuery({ truckId: truckId ? [truckId] : undefined })} />
      </div>
      <Select
        allowClear
        className="w-full md:w-56"
        placeholder="All work orders"
        aria-label="Whose work orders"
        options={SCOPE_OPTIONS}
        value={query.scope}
        onChange={(scope) => setQuery({ scope })}
      />
    </>
  );
}
